import type { GetFiltersListDto } from '@/domains/filters';
import { useQuery } from '@tanstack/react-query';

import { filtersQueryKeys } from '@/domains/filters';

export const useFiltersQuery = (query: GetFiltersListDto) => {
  const { isLoading, data } = useQuery({
    ...filtersQueryKeys.list(query),
    // @ts-ignore
    retry: false,
    keepPreviousData: true,
  });

  return {
    isLoading,
    data,
  };
};
